import { render, staticRenderFns } from "./SuccessSubmitForm16.vue?vue&type=template&id=7d982fc3&scoped=true"
import script from "./SuccessSubmitForm16.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm16.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d982fc3",
  null
  
)

export default component.exports